import { render } from "./CosmoSettings.vue?vue&type=template&id=82364986&scoped=true"
import script from "./CosmoSettings.vue?vue&type=script&lang=js"
export * from "./CosmoSettings.vue?vue&type=script&lang=js"

import "./CosmoSettings.vue?vue&type=style&index=0&id=82364986&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82364986"]])

export default __exports__